/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type AdditionalDataHolder, type ApiError, type Parsable, type ParseNode, type SerializationWriter } from '@microsoft/kiota-abstractions';

/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FastEndpointsInternalErrorResponse}
 */
// @ts-ignore
export function createFastEndpointsInternalErrorResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFastEndpointsInternalErrorResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartCouponPutRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartCouponPutRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartCouponPutRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartCouponPutResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartCouponPutResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartCouponPutResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartCreateRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartCreateResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartCreateResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartCreateResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartFinalizeRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartFinalizeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartFinalizeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartFinalizeResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartFinalizeResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartFinalizeResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartGetResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemAddOnAddRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemAddOnAddRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemAddOnAddRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemAddOnAddResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemAddOnAddResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemAddOnAddResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemDeleteResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemDeleteResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemDeleteResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemDomainAddRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemDomainAddRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemDomainAddRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemDomainAddResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemDomainAddResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemDomainAddResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemMicrosoft365AddRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemMicrosoft365AddResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemMicrosoft365PutRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemMicrosoft365PutResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemVpsAddRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemVpsAddRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemVpsAddRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartItemVpsAddResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartItemVpsAddResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartItemVpsAddResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartLinkToCustomerRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartLinkToCustomerRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartLinkToCustomerRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartLinkToCustomerResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartLinkToCustomerResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartLinkToCustomerResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartOrderPrepareRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartOrderPrepareRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartOrderPrepareRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartOrderPrepareResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartOrderPrepareResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartOrderPrepareResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartQuoteRequest}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartQuoteRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartQuoteRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartQuoteResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartQuoteResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartQuoteResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceededFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogTldGetResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogTldGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogTldGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesCatalogVpsGetResponse}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesCatalogVpsGetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesCatalogVpsGetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesSharedModelsAddOnCartItem}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesSharedModelsAddOnCartItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesSharedModelsAddOnCartItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesSharedModelsCartItem}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesSharedModelsCartItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesSharedModelsCartItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesSharedModelsDomainCartItem}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesSharedModelsDomainCartItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesSharedModelsDomainCartItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem}
 */
// @ts-ignore
export function createWebhusetOrderApiFeaturesSharedModelsVirtualServerCartItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddRestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto}
 */
// @ts-ignore
export function createWebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto;
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFastEndpointsInternalErrorResponse(fastEndpointsInternalErrorResponse: Partial<FastEndpointsInternalErrorResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "code": n => { fastEndpointsInternalErrorResponse.code = n.getNumberValue(); },
        "note": n => { fastEndpointsInternalErrorResponse.note = n.getStringValue() ?? "See application log for stack trace."; },
        "reason": n => { fastEndpointsInternalErrorResponse.reason = n.getStringValue() ?? "Something unexpected has happened"; },
        "status": n => { fastEndpointsInternalErrorResponse.status = n.getStringValue() ?? "Internal Server Error!"; },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartCouponPutRequest(webhusetOrderApiFeaturesCartCouponPutRequest: Partial<WebhusetOrderApiFeaturesCartCouponPutRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "coupon": n => { webhusetOrderApiFeaturesCartCouponPutRequest.coupon = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartCouponPutResponse(webhusetOrderApiFeaturesCartCouponPutResponse: Partial<WebhusetOrderApiFeaturesCartCouponPutResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { webhusetOrderApiFeaturesCartCouponPutResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartCreateRequest(webhusetOrderApiFeaturesCartCreateRequest: Partial<WebhusetOrderApiFeaturesCartCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "companyProfileId": n => { webhusetOrderApiFeaturesCartCreateRequest.companyProfileId = n.getNumberValue(); },
        "deviceType": n => { webhusetOrderApiFeaturesCartCreateRequest.deviceType = n.getEnumValue<WebhusetOrderApiDataCustomerDeviceTypeItem>(WebhusetOrderApiDataCustomerDeviceTypeItemObject); },
        "isPpc": n => { webhusetOrderApiFeaturesCartCreateRequest.isPpc = n.getBooleanValue(); },
        "utmCampaign": n => { webhusetOrderApiFeaturesCartCreateRequest.utmCampaign = n.getStringValue(); },
        "utmTerm": n => { webhusetOrderApiFeaturesCartCreateRequest.utmTerm = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartCreateResponse(webhusetOrderApiFeaturesCartCreateResponse: Partial<WebhusetOrderApiFeaturesCartCreateResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "domainSubscriptionPaymentInterval": n => { webhusetOrderApiFeaturesCartCreateResponse.domainSubscriptionPaymentInterval = n.getEnumValue<WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem>(WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItemObject); },
        "id": n => { webhusetOrderApiFeaturesCartCreateResponse.id = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest(webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest: Partial<WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "domainSubscriptionPaymentInterval": n => { webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest.domainSubscriptionPaymentInterval = n.getEnumValue<WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem>(WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItemObject); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse(webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse: Partial<WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartFinalizeRequest(webhusetOrderApiFeaturesCartFinalizeRequest: Partial<WebhusetOrderApiFeaturesCartFinalizeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderId": n => { webhusetOrderApiFeaturesCartFinalizeRequest.orderId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartFinalizeResponse(webhusetOrderApiFeaturesCartFinalizeResponse: Partial<WebhusetOrderApiFeaturesCartFinalizeResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { webhusetOrderApiFeaturesCartFinalizeResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartGetResponse(webhusetOrderApiFeaturesCartGetResponse: Partial<WebhusetOrderApiFeaturesCartGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "coupon": n => { webhusetOrderApiFeaturesCartGetResponse.coupon = n.getStringValue(); },
        "domainSubscriptionPaymentInterval": n => { webhusetOrderApiFeaturesCartGetResponse.domainSubscriptionPaymentInterval = n.getEnumValue<WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem>(WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItemObject); },
        "isFinalized": n => { webhusetOrderApiFeaturesCartGetResponse.isFinalized = n.getBooleanValue(); },
        "items": n => { webhusetOrderApiFeaturesCartGetResponse.items = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesSharedModelsCartItem>(createWebhusetOrderApiFeaturesSharedModelsCartItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemAddOnAddRequest(webhusetOrderApiFeaturesCartItemAddOnAddRequest: Partial<WebhusetOrderApiFeaturesCartItemAddOnAddRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addOnId": n => { webhusetOrderApiFeaturesCartItemAddOnAddRequest.addOnId = n.getNumberValue(); },
        "replacesAddOnIds": n => { webhusetOrderApiFeaturesCartItemAddOnAddRequest.replacesAddOnIds = n.getCollectionOfPrimitiveValues<number>(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemAddOnAddResponse(webhusetOrderApiFeaturesCartItemAddOnAddResponse: Partial<WebhusetOrderApiFeaturesCartItemAddOnAddResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "item": n => { webhusetOrderApiFeaturesCartItemAddOnAddResponse.item = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>(createWebhusetOrderApiFeaturesSharedModelsCartItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemDeleteResponse(webhusetOrderApiFeaturesCartItemDeleteResponse: Partial<WebhusetOrderApiFeaturesCartItemDeleteResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { webhusetOrderApiFeaturesCartItemDeleteResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemDomainAddRequest(webhusetOrderApiFeaturesCartItemDomainAddRequest: Partial<WebhusetOrderApiFeaturesCartItemDomainAddRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "domain": n => { webhusetOrderApiFeaturesCartItemDomainAddRequest.domain = n.getStringValue(); },
        "registrationType": n => { webhusetOrderApiFeaturesCartItemDomainAddRequest.registrationType = n.getEnumValue<WebhusetOrderApiDataDomainRegistrationType>(WebhusetOrderApiDataDomainRegistrationTypeObject); },
        "tld": n => { webhusetOrderApiFeaturesCartItemDomainAddRequest.tld = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemDomainAddResponse(webhusetOrderApiFeaturesCartItemDomainAddResponse: Partial<WebhusetOrderApiFeaturesCartItemDomainAddResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "item": n => { webhusetOrderApiFeaturesCartItemDomainAddResponse.item = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>(createWebhusetOrderApiFeaturesSharedModelsCartItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest(webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest: Partial<WebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alternateEmail": n => { webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.alternateEmail = n.getStringValue(); },
        "firstName": n => { webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.firstName = n.getStringValue(); },
        "hasCoPilot": n => { webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.hasCoPilot = n.getBooleanValue(); },
        "lastName": n => { webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.lastName = n.getStringValue(); },
        "subscriptionId": n => { webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.subscriptionId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse(webhusetOrderApiFeaturesCartItemMicrosoft365AddResponse: Partial<WebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "item": n => { webhusetOrderApiFeaturesCartItemMicrosoft365AddResponse.item = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>(createWebhusetOrderApiFeaturesSharedModelsCartItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest(webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest: Partial<WebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alternateEmail": n => { webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.alternateEmail = n.getStringValue(); },
        "firstName": n => { webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.firstName = n.getStringValue(); },
        "hasCoPilot": n => { webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.hasCoPilot = n.getBooleanValue(); },
        "lastName": n => { webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.lastName = n.getStringValue(); },
        "subscriptionId": n => { webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.subscriptionId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse(webhusetOrderApiFeaturesCartItemMicrosoft365PutResponse: Partial<WebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "item": n => { webhusetOrderApiFeaturesCartItemMicrosoft365PutResponse.item = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>(createWebhusetOrderApiFeaturesSharedModelsCartItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemVpsAddRequest(webhusetOrderApiFeaturesCartItemVpsAddRequest: Partial<WebhusetOrderApiFeaturesCartItemVpsAddRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "subscriptionId": n => { webhusetOrderApiFeaturesCartItemVpsAddRequest.subscriptionId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartItemVpsAddResponse(webhusetOrderApiFeaturesCartItemVpsAddResponse: Partial<WebhusetOrderApiFeaturesCartItemVpsAddResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "item": n => { webhusetOrderApiFeaturesCartItemVpsAddResponse.item = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>(createWebhusetOrderApiFeaturesSharedModelsCartItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartLinkToCustomerRequest(webhusetOrderApiFeaturesCartLinkToCustomerRequest: Partial<WebhusetOrderApiFeaturesCartLinkToCustomerRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerId": n => { webhusetOrderApiFeaturesCartLinkToCustomerRequest.customerId = n.getNumberValue(); },
        "partnerId": n => { webhusetOrderApiFeaturesCartLinkToCustomerRequest.partnerId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartLinkToCustomerResponse(webhusetOrderApiFeaturesCartLinkToCustomerResponse: Partial<WebhusetOrderApiFeaturesCartLinkToCustomerResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "success": n => { webhusetOrderApiFeaturesCartLinkToCustomerResponse.success = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto(webhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto: Partial<WebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddRestDto(webhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto),
        "return_url": n => { webhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto.returnUrl = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartOrderPrepareRequest(webhusetOrderApiFeaturesCartOrderPrepareRequest: Partial<WebhusetOrderApiFeaturesCartOrderPrepareRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "paymentMethod": n => { webhusetOrderApiFeaturesCartOrderPrepareRequest.paymentMethod = n.getEnumValue<WebhusetOrderApiDataOrderPaymentMethodTypeItem>(WebhusetOrderApiDataOrderPaymentMethodTypeItemObject); },
        "returnUrl": n => { webhusetOrderApiFeaturesCartOrderPrepareRequest.returnUrl = n.getStringValue(); },
        "smsVerificationTransactionId": n => { webhusetOrderApiFeaturesCartOrderPrepareRequest.smsVerificationTransactionId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartOrderPrepareResponse(webhusetOrderApiFeaturesCartOrderPrepareResponse: Partial<WebhusetOrderApiFeaturesCartOrderPrepareResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "orderData": n => { webhusetOrderApiFeaturesCartOrderPrepareResponse.orderData = n.getObjectValue<WebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto>(createWebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartQuoteRequest(webhusetOrderApiFeaturesCartQuoteRequest: Partial<WebhusetOrderApiFeaturesCartQuoteRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiKey": n => { webhusetOrderApiFeaturesCartQuoteRequest.apiKey = n.getStringValue(); },
        "impersonateCustomerId": n => { webhusetOrderApiFeaturesCartQuoteRequest.impersonateCustomerId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartQuoteResponse(webhusetOrderApiFeaturesCartQuoteResponse: Partial<WebhusetOrderApiFeaturesCartQuoteResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "sumFirstInvoiceExVat": n => { webhusetOrderApiFeaturesCartQuoteResponse.sumFirstInvoiceExVat = n.getNumberValue(); },
        "sumFirstInvoiceIncVat": n => { webhusetOrderApiFeaturesCartQuoteResponse.sumFirstInvoiceIncVat = n.getNumberValue(); },
        "sumVatFirstInvoice": n => { webhusetOrderApiFeaturesCartQuoteResponse.sumVatFirstInvoice = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded(webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded: Partial<WebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        ...deserializeIntoWebhusetOrderApiFeaturesCartQuoteResponse(webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded),
        "domainsWithDiscountAlreadyExistCount": n => { webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded.domainsWithDiscountAlreadyExistCount = n.getNumberValue(); },
        "domainsWithDiscountInCurrentOrderCount": n => { webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded.domainsWithDiscountInCurrentOrderCount = n.getNumberValue(); },
        "domainsWithDiscountMaxCount": n => { webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded.domainsWithDiscountMaxCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse(webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse: Partial<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "products": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse.products = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto>(createWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto(webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addOnType": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto.addOnType = n.getNumberValue(); },
        "name": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto.name = n.getStringValue(); },
        "subscriptions": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto.subscriptions = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto>(createWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto(webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto: Partial<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addOnId": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.addOnId = n.getNumberValue(); },
        "agreementPeriodType": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.agreementPeriodType = n.getEnumValue<WebhusetConstantsOrderAgreementPeriodTypeItem>(WebhusetConstantsOrderAgreementPeriodTypeItemObject); },
        "name": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.name = n.getStringValue(); },
        "priceRecurring": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.priceRecurring = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "priceStartup": n => { webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.priceStartup = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse(webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse: Partial<WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "options": n => { webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse.options = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto>(createWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto(webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "individuals": n => { webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto.individuals = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "invoiceMethodItem": n => { webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto.invoiceMethodItem = n.getEnumValue<WebhusetOrderApiDataInvoicePaymentMethodTypeItem>(WebhusetOrderApiDataInvoicePaymentMethodTypeItemObject); },
        "name": n => { webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto.name = n.getStringValue(); },
        "organizations": n => { webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto.organizations = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse(webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse: Partial<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "products": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse.products = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto>(createWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto(webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto.name = n.getStringValue(); },
        "packageId": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto.packageId = n.getNumberValue(); },
        "subscriptions": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto.subscriptions = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto>(createWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto(webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto: Partial<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "agreementPeriodType": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.agreementPeriodType = n.getEnumValue<WebhusetConstantsOrderAgreementPeriodTypeItem>(WebhusetConstantsOrderAgreementPeriodTypeItemObject); },
        "priceRecurring": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.priceRecurring = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "priceStartup": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.priceStartup = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "subscriptionId": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.subscriptionId = n.getNumberValue(); },
        "subscriptionName": n => { webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.subscriptionName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogTldGetResponse(webhusetOrderApiFeaturesCatalogTldGetResponse: Partial<WebhusetOrderApiFeaturesCatalogTldGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "products": n => { webhusetOrderApiFeaturesCatalogTldGetResponse.products = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto>(createWebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto(webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "priceRecurring": n => { webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto.priceRecurring = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "priceStartup": n => { webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto.priceStartup = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "tld": n => { webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto.tld = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse(webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse: Partial<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "products": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse.products = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto>(createWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto(webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addOnType": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto.addOnType = n.getNumberValue(); },
        "name": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto.name = n.getStringValue(); },
        "subscriptions": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto.subscriptions = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto>(createWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto(webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto: Partial<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addOnId": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.addOnId = n.getNumberValue(); },
        "agreementPeriodType": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.agreementPeriodType = n.getEnumValue<WebhusetConstantsOrderAgreementPeriodTypeItem>(WebhusetConstantsOrderAgreementPeriodTypeItemObject); },
        "name": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.name = n.getStringValue(); },
        "priceRecurring": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.priceRecurring = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "priceStartup": n => { webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.priceStartup = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogVpsGetResponse(webhusetOrderApiFeaturesCatalogVpsGetResponse: Partial<WebhusetOrderApiFeaturesCatalogVpsGetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "products": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse.products = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto>(createWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto(webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "distroId": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.distroId = n.getNumberValue(); },
        "osFamily": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.osFamily = n.getNumberValue(); },
        "subscriptions": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.subscriptions = n.getCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto>(createWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDtoFromDiscriminatorValue); },
        "templateId": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.templateId = n.getNumberValue(); },
        "templateName": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.templateName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto(webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto: Partial<WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "agreementPeriodType": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.agreementPeriodType = n.getEnumValue<WebhusetConstantsOrderAgreementPeriodTypeItem>(WebhusetConstantsOrderAgreementPeriodTypeItemObject); },
        "cpuCount": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.cpuCount = n.getNumberValue(); },
        "diskInGb": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.diskInGb = n.getNumberValue(); },
        "memoryInGb": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.memoryInGb = n.getNumberValue(); },
        "priceRecurring": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.priceRecurring = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "priceStartup": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.priceStartup = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>(createWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDtoFromDiscriminatorValue); },
        "subscriptionId": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.subscriptionId = n.getNumberValue(); },
        "subscriptionName": n => { webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.subscriptionName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesSharedModelsAddOnCartItem(webhusetOrderApiFeaturesSharedModelsAddOnCartItem: Partial<WebhusetOrderApiFeaturesSharedModelsAddOnCartItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addOnId": n => { webhusetOrderApiFeaturesSharedModelsAddOnCartItem.addOnId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesSharedModelsCartItem(webhusetOrderApiFeaturesSharedModelsCartItem: Partial<WebhusetOrderApiFeaturesSharedModelsCartItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addOn": n => { webhusetOrderApiFeaturesSharedModelsCartItem.addOn = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsAddOnCartItem>(createWebhusetOrderApiFeaturesSharedModelsAddOnCartItemFromDiscriminatorValue); },
        "chat": n => { webhusetOrderApiFeaturesSharedModelsCartItem.chat = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsDomainCartItem>(createWebhusetOrderApiFeaturesSharedModelsDomainCartItemFromDiscriminatorValue); },
        "domain": n => { webhusetOrderApiFeaturesSharedModelsCartItem.domain = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsDomainCartItem>(createWebhusetOrderApiFeaturesSharedModelsDomainCartItemFromDiscriminatorValue); },
        "id": n => { webhusetOrderApiFeaturesSharedModelsCartItem.id = n.getStringValue(); },
        "microsoft365": n => { webhusetOrderApiFeaturesSharedModelsCartItem.microsoft365 = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem>(createWebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItemFromDiscriminatorValue); },
        "parentItemId": n => { webhusetOrderApiFeaturesSharedModelsCartItem.parentItemId = n.getStringValue(); },
        "virtualServer": n => { webhusetOrderApiFeaturesSharedModelsCartItem.virtualServer = n.getObjectValue<WebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem>(createWebhusetOrderApiFeaturesSharedModelsVirtualServerCartItemFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto(webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto: Partial<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "description": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.description = n.getStringValue(); },
        "discount": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.discount = n.getNumberValue(); },
        "discountValue": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.discountValue = n.getNumberValue(); },
        "duration": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.duration = n.getNumberValue(); },
        "priceExVat": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.priceExVat = n.getNumberValue(); },
        "priceIncVat": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.priceIncVat = n.getNumberValue(); },
        "unitPrice": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.unitPrice = n.getNumberValue(); },
        "unitPriceWithDiscount": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.unitPriceWithDiscount = n.getNumberValue(); },
        "units": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.units = n.getNumberValue(); },
        "vat": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.vat = n.getNumberValue(); },
        "vatValue": n => { webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.vatValue = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesSharedModelsDomainCartItem(webhusetOrderApiFeaturesSharedModelsDomainCartItem: Partial<WebhusetOrderApiFeaturesSharedModelsDomainCartItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "domain": n => { webhusetOrderApiFeaturesSharedModelsDomainCartItem.domain = n.getStringValue(); },
        "fqdn": n => { webhusetOrderApiFeaturesSharedModelsDomainCartItem.fqdn = n.getStringValue(); },
        "registrationType": n => { webhusetOrderApiFeaturesSharedModelsDomainCartItem.registrationType = n.getEnumValue<WebhusetOrderApiDataDomainRegistrationType>(WebhusetOrderApiDataDomainRegistrationTypeObject); },
        "tld": n => { webhusetOrderApiFeaturesSharedModelsDomainCartItem.tld = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem(webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem: Partial<WebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alternateEmail": n => { webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.alternateEmail = n.getStringValue(); },
        "firstName": n => { webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.firstName = n.getStringValue(); },
        "hasCoPilot": n => { webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.hasCoPilot = n.getBooleanValue(); },
        "lastName": n => { webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.lastName = n.getStringValue(); },
        "subscriptionId": n => { webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.subscriptionId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem(webhusetOrderApiFeaturesSharedModelsVirtualServerCartItem: Partial<WebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "subscriptionId": n => { webhusetOrderApiFeaturesSharedModelsVirtualServerCartItem.subscriptionId = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto(webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto.email = n.getStringValue(); },
        "onboarding_id": n => { webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto.onboardingId = n.getStringValue(); },
        "subscription": n => { webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto.subscription = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto(webhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addon": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto.addon = n.getNumberValue(); },
        "domain": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto.domain = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto(webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addons": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.addons = n.getCollectionOfPrimitiveValues<number>(); },
        "domain": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.domain = n.getStringValue(); },
        "is_temporary": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.isTemporary = n.getBooleanValue(); },
        "is_third_party": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.isThirdParty = n.getBooleanValue(); },
        "os": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.os = n.getNumberValue(); },
        "registration_type": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.registrationType = n.getNumberValue(); },
        "subscription": n => { webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.subscription = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto(webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alternate_email": n => { webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto.alternateEmail = n.getStringValue(); },
        "first_name": n => { webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto.firstName = n.getStringValue(); },
        "last_name": n => { webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto.lastName = n.getStringValue(); },
        "subscription": n => { webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto.subscription = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto(webhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addons": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto.addons = n.getCollectionOfPrimitiveValues<number>(); },
        "subscription": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto.subscription = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddRestDto(webhusetOuterfaceApiRestDtoOrderOrderAddRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "automatic_recurring_payment": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.automaticRecurringPayment = n.getBooleanValue(); },
        "chats": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.chats = n.getCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDtoFromDiscriminatorValue); },
        "checkout_key": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.checkoutKey = n.getStringValue(); },
        "client_ip_address": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.clientIpAddress = n.getStringValue(); },
        "comment": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.comment = n.getStringValue(); },
        "coupon": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.coupon = n.getStringValue(); },
        "customerid": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.customerid = n.getNumberValue(); },
        "domain_addon": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.domainAddon = n.getObjectValue<WebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDtoFromDiscriminatorValue); },
        "domains": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.domains = n.getCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDtoFromDiscriminatorValue); },
        "is_ppc": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.isPpc = n.getBooleanValue(); },
        "office365s": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.office365s = n.getCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDtoFromDiscriminatorValue); },
        "partnerid": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.partnerid = n.getNumberValue(); },
        "payment_type": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.paymentType = n.getNumberValue(); },
        "racks": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.racks = n.getCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDtoFromDiscriminatorValue); },
        "server_addon": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.serverAddon = n.getObjectValue<WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDtoFromDiscriminatorValue); },
        "server_addons": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.serverAddons = n.getCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDtoFromDiscriminatorValue); },
        "servers": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.servers = n.getCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDtoFromDiscriminatorValue); },
        "sms_verify_code_id": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.smsVerifyCodeId = n.getNumberValue(); },
        "utm_campaign": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.utmCampaign = n.getStringValue(); },
        "utm_term": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.utmTerm = n.getStringValue(); },
        "vpsclones": n => { webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.vpsclones = n.getCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto>(createWebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto(webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addon": n => { webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto.addon = n.getNumberValue(); },
        "changedfromserveraddonid": n => { webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto.changedfromserveraddonid = n.getNumberValue(); },
        "server": n => { webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto.server = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto(webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addons": n => { webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto.addons = n.getCollectionOfPrimitiveValues<number>(); },
        "availability_zone": n => { webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto.availabilityZone = n.getNumberValue(); },
        "subscription": n => { webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto.subscription = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto(webhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "serverid": n => { webhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto.serverid = n.getNumberValue(); },
        "target_subscription": n => { webhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto.targetSubscription = n.getNumberValue(); },
    }
}
/**
 * the dto used to send an error response to the client when an unhandled exception occurs on the server
 */
export interface FastEndpointsInternalErrorResponse extends ApiError, Parsable {
    /**
     * http status code of the error response
     */
    code?: number | null;
    /**
     * additional information or instructions
     */
    note?: string | null;
    /**
     * the reason for the error
     */
    reason?: string | null;
    /**
     * error status
     */
    status?: string | null;
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFastEndpointsInternalErrorResponse(writer: SerializationWriter, fastEndpointsInternalErrorResponse: Partial<FastEndpointsInternalErrorResponse> | undefined | null = {}) : void {
    if (fastEndpointsInternalErrorResponse) {
        writer.writeNumberValue("code", fastEndpointsInternalErrorResponse.code);
        writer.writeStringValue("note", fastEndpointsInternalErrorResponse.note ?? "See application log for stack trace.");
        writer.writeStringValue("reason", fastEndpointsInternalErrorResponse.reason ?? "Something unexpected has happened");
        writer.writeStringValue("status", fastEndpointsInternalErrorResponse.status ?? "Internal Server Error!");
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartCouponPutRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartCouponPutRequest: Partial<WebhusetOrderApiFeaturesCartCouponPutRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartCouponPutRequest) {
        writer.writeStringValue("coupon", webhusetOrderApiFeaturesCartCouponPutRequest.coupon);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartCouponPutResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartCouponPutResponse: Partial<WebhusetOrderApiFeaturesCartCouponPutResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartCouponPutResponse) {
        writer.writeBooleanValue("success", webhusetOrderApiFeaturesCartCouponPutResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartCreateRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartCreateRequest: Partial<WebhusetOrderApiFeaturesCartCreateRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartCreateRequest) {
        writer.writeNumberValue("companyProfileId", webhusetOrderApiFeaturesCartCreateRequest.companyProfileId);
        writer.writeEnumValue<WebhusetOrderApiDataCustomerDeviceTypeItem>("deviceType", webhusetOrderApiFeaturesCartCreateRequest.deviceType);
        writer.writeBooleanValue("isPpc", webhusetOrderApiFeaturesCartCreateRequest.isPpc);
        writer.writeStringValue("utmCampaign", webhusetOrderApiFeaturesCartCreateRequest.utmCampaign);
        writer.writeStringValue("utmTerm", webhusetOrderApiFeaturesCartCreateRequest.utmTerm);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartCreateResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartCreateResponse: Partial<WebhusetOrderApiFeaturesCartCreateResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartCreateResponse) {
        writer.writeEnumValue<WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem>("domainSubscriptionPaymentInterval", webhusetOrderApiFeaturesCartCreateResponse.domainSubscriptionPaymentInterval);
        writer.writeStringValue("id", webhusetOrderApiFeaturesCartCreateResponse.id);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest: Partial<WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest) {
        writer.writeEnumValue<WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem>("domainSubscriptionPaymentInterval", webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest.domainSubscriptionPaymentInterval);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse: Partial<WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse) {
        writer.writeBooleanValue("success", webhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartFinalizeRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartFinalizeRequest: Partial<WebhusetOrderApiFeaturesCartFinalizeRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartFinalizeRequest) {
        writer.writeNumberValue("orderId", webhusetOrderApiFeaturesCartFinalizeRequest.orderId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartFinalizeResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartFinalizeResponse: Partial<WebhusetOrderApiFeaturesCartFinalizeResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartFinalizeResponse) {
        writer.writeBooleanValue("success", webhusetOrderApiFeaturesCartFinalizeResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartGetResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartGetResponse: Partial<WebhusetOrderApiFeaturesCartGetResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartGetResponse) {
        writer.writeStringValue("coupon", webhusetOrderApiFeaturesCartGetResponse.coupon);
        writer.writeEnumValue<WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem>("domainSubscriptionPaymentInterval", webhusetOrderApiFeaturesCartGetResponse.domainSubscriptionPaymentInterval);
        writer.writeBooleanValue("isFinalized", webhusetOrderApiFeaturesCartGetResponse.isFinalized);
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesSharedModelsCartItem>("items", webhusetOrderApiFeaturesCartGetResponse.items, serializeWebhusetOrderApiFeaturesSharedModelsCartItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemAddOnAddRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemAddOnAddRequest: Partial<WebhusetOrderApiFeaturesCartItemAddOnAddRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemAddOnAddRequest) {
        writer.writeNumberValue("addOnId", webhusetOrderApiFeaturesCartItemAddOnAddRequest.addOnId);
        writer.writeCollectionOfPrimitiveValues<number>("replacesAddOnIds", webhusetOrderApiFeaturesCartItemAddOnAddRequest.replacesAddOnIds);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemAddOnAddResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemAddOnAddResponse: Partial<WebhusetOrderApiFeaturesCartItemAddOnAddResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemAddOnAddResponse) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>("item", webhusetOrderApiFeaturesCartItemAddOnAddResponse.item, serializeWebhusetOrderApiFeaturesSharedModelsCartItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemDeleteResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemDeleteResponse: Partial<WebhusetOrderApiFeaturesCartItemDeleteResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemDeleteResponse) {
        writer.writeBooleanValue("success", webhusetOrderApiFeaturesCartItemDeleteResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemDomainAddRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemDomainAddRequest: Partial<WebhusetOrderApiFeaturesCartItemDomainAddRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemDomainAddRequest) {
        writer.writeStringValue("domain", webhusetOrderApiFeaturesCartItemDomainAddRequest.domain);
        writer.writeEnumValue<WebhusetOrderApiDataDomainRegistrationType>("registrationType", webhusetOrderApiFeaturesCartItemDomainAddRequest.registrationType);
        writer.writeStringValue("tld", webhusetOrderApiFeaturesCartItemDomainAddRequest.tld);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemDomainAddResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemDomainAddResponse: Partial<WebhusetOrderApiFeaturesCartItemDomainAddResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemDomainAddResponse) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>("item", webhusetOrderApiFeaturesCartItemDomainAddResponse.item, serializeWebhusetOrderApiFeaturesSharedModelsCartItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest: Partial<WebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest) {
        writer.writeStringValue("alternateEmail", webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.alternateEmail);
        writer.writeStringValue("firstName", webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.firstName);
        writer.writeBooleanValue("hasCoPilot", webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.hasCoPilot);
        writer.writeStringValue("lastName", webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.lastName);
        writer.writeNumberValue("subscriptionId", webhusetOrderApiFeaturesCartItemMicrosoft365AddRequest.subscriptionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemMicrosoft365AddResponse: Partial<WebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemMicrosoft365AddResponse) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>("item", webhusetOrderApiFeaturesCartItemMicrosoft365AddResponse.item, serializeWebhusetOrderApiFeaturesSharedModelsCartItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest: Partial<WebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest) {
        writer.writeStringValue("alternateEmail", webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.alternateEmail);
        writer.writeStringValue("firstName", webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.firstName);
        writer.writeBooleanValue("hasCoPilot", webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.hasCoPilot);
        writer.writeStringValue("lastName", webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.lastName);
        writer.writeNumberValue("subscriptionId", webhusetOrderApiFeaturesCartItemMicrosoft365PutRequest.subscriptionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemMicrosoft365PutResponse: Partial<WebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemMicrosoft365PutResponse) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>("item", webhusetOrderApiFeaturesCartItemMicrosoft365PutResponse.item, serializeWebhusetOrderApiFeaturesSharedModelsCartItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemVpsAddRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemVpsAddRequest: Partial<WebhusetOrderApiFeaturesCartItemVpsAddRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemVpsAddRequest) {
        writer.writeNumberValue("subscriptionId", webhusetOrderApiFeaturesCartItemVpsAddRequest.subscriptionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartItemVpsAddResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartItemVpsAddResponse: Partial<WebhusetOrderApiFeaturesCartItemVpsAddResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartItemVpsAddResponse) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCartItem>("item", webhusetOrderApiFeaturesCartItemVpsAddResponse.item, serializeWebhusetOrderApiFeaturesSharedModelsCartItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartLinkToCustomerRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartLinkToCustomerRequest: Partial<WebhusetOrderApiFeaturesCartLinkToCustomerRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartLinkToCustomerRequest) {
        writer.writeNumberValue("customerId", webhusetOrderApiFeaturesCartLinkToCustomerRequest.customerId);
        writer.writeNumberValue("partnerId", webhusetOrderApiFeaturesCartLinkToCustomerRequest.partnerId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartLinkToCustomerResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartLinkToCustomerResponse: Partial<WebhusetOrderApiFeaturesCartLinkToCustomerResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartLinkToCustomerResponse) {
        writer.writeBooleanValue("success", webhusetOrderApiFeaturesCartLinkToCustomerResponse.success);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto: Partial<WebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto) {
        serializeWebhusetOuterfaceApiRestDtoOrderOrderAddRestDto(writer, webhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto)
        writer.writeStringValue("return_url", webhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto.returnUrl);
        writer.writeAdditionalData(webhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartOrderPrepareRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartOrderPrepareRequest: Partial<WebhusetOrderApiFeaturesCartOrderPrepareRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartOrderPrepareRequest) {
        writer.writeEnumValue<WebhusetOrderApiDataOrderPaymentMethodTypeItem>("paymentMethod", webhusetOrderApiFeaturesCartOrderPrepareRequest.paymentMethod);
        writer.writeStringValue("returnUrl", webhusetOrderApiFeaturesCartOrderPrepareRequest.returnUrl);
        writer.writeNumberValue("smsVerificationTransactionId", webhusetOrderApiFeaturesCartOrderPrepareRequest.smsVerificationTransactionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartOrderPrepareResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartOrderPrepareResponse: Partial<WebhusetOrderApiFeaturesCartOrderPrepareResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartOrderPrepareResponse) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto>("orderData", webhusetOrderApiFeaturesCartOrderPrepareResponse.orderData, serializeWebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartQuoteRequest(writer: SerializationWriter, webhusetOrderApiFeaturesCartQuoteRequest: Partial<WebhusetOrderApiFeaturesCartQuoteRequest> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartQuoteRequest) {
        writer.writeStringValue("apiKey", webhusetOrderApiFeaturesCartQuoteRequest.apiKey);
        writer.writeNumberValue("impersonateCustomerId", webhusetOrderApiFeaturesCartQuoteRequest.impersonateCustomerId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartQuoteResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCartQuoteResponse: Partial<WebhusetOrderApiFeaturesCartQuoteResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartQuoteResponse) {
        writer.writeNumberValue("sumFirstInvoiceExVat", webhusetOrderApiFeaturesCartQuoteResponse.sumFirstInvoiceExVat);
        writer.writeNumberValue("sumFirstInvoiceIncVat", webhusetOrderApiFeaturesCartQuoteResponse.sumFirstInvoiceIncVat);
        writer.writeNumberValue("sumVatFirstInvoice", webhusetOrderApiFeaturesCartQuoteResponse.sumVatFirstInvoice);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded(writer: SerializationWriter, webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded: Partial<WebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded) {
        serializeWebhusetOrderApiFeaturesCartQuoteResponse(writer, webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded)
        writer.writeNumberValue("domainsWithDiscountAlreadyExistCount", webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded.domainsWithDiscountAlreadyExistCount);
        writer.writeNumberValue("domainsWithDiscountInCurrentOrderCount", webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded.domainsWithDiscountInCurrentOrderCount);
        writer.writeNumberValue("domainsWithDiscountMaxCount", webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded.domainsWithDiscountMaxCount);
        writer.writeAdditionalData(webhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded.additionalData);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse: Partial<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse) {
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto>("products", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse.products, serializeWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto) {
        writer.writeNumberValue("addOnType", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto.addOnType);
        writer.writeStringValue("name", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto.name);
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto>("subscriptions", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto.subscriptions, serializeWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto: Partial<WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto) {
        writer.writeNumberValue("addOnId", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.addOnId);
        writer.writeEnumValue<WebhusetConstantsOrderAgreementPeriodTypeItem>("agreementPeriodType", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.agreementPeriodType);
        writer.writeStringValue("name", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.name);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceRecurring", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.priceRecurring, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceStartup", webhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto.priceStartup, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse: Partial<WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse) {
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto>("options", webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse.options, serializeWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("individuals", webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto.individuals, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeEnumValue<WebhusetOrderApiDataInvoicePaymentMethodTypeItem>("invoiceMethodItem", webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto.invoiceMethodItem);
        writer.writeStringValue("name", webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto.name);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("organizations", webhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto.organizations, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse: Partial<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse) {
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto>("products", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse.products, serializeWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto) {
        writer.writeStringValue("name", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto.name);
        writer.writeNumberValue("packageId", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto.packageId);
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto>("subscriptions", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto.subscriptions, serializeWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto: Partial<WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto) {
        writer.writeEnumValue<WebhusetConstantsOrderAgreementPeriodTypeItem>("agreementPeriodType", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.agreementPeriodType);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceRecurring", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.priceRecurring, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceStartup", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.priceStartup, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeNumberValue("subscriptionId", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.subscriptionId);
        writer.writeStringValue("subscriptionName", webhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto.subscriptionName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogTldGetResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogTldGetResponse: Partial<WebhusetOrderApiFeaturesCatalogTldGetResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogTldGetResponse) {
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto>("products", webhusetOrderApiFeaturesCatalogTldGetResponse.products, serializeWebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceRecurring", webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto.priceRecurring, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceStartup", webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto.priceStartup, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeStringValue("tld", webhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto.tld);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse: Partial<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse) {
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto>("products", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse.products, serializeWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto) {
        writer.writeNumberValue("addOnType", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto.addOnType);
        writer.writeStringValue("name", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto.name);
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto>("subscriptions", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto.subscriptions, serializeWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto: Partial<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto) {
        writer.writeNumberValue("addOnId", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.addOnId);
        writer.writeEnumValue<WebhusetConstantsOrderAgreementPeriodTypeItem>("agreementPeriodType", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.agreementPeriodType);
        writer.writeStringValue("name", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.name);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceRecurring", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.priceRecurring, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceStartup", webhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto.priceStartup, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogVpsGetResponse(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogVpsGetResponse: Partial<WebhusetOrderApiFeaturesCatalogVpsGetResponse> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogVpsGetResponse) {
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto>("products", webhusetOrderApiFeaturesCatalogVpsGetResponse.products, serializeWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto: Partial<WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto) {
        writer.writeNumberValue("distroId", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.distroId);
        writer.writeNumberValue("osFamily", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.osFamily);
        writer.writeCollectionOfObjectValues<WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto>("subscriptions", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.subscriptions, serializeWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto);
        writer.writeNumberValue("templateId", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.templateId);
        writer.writeStringValue("templateName", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto.templateName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto: Partial<WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto) {
        writer.writeEnumValue<WebhusetConstantsOrderAgreementPeriodTypeItem>("agreementPeriodType", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.agreementPeriodType);
        writer.writeNumberValue("cpuCount", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.cpuCount);
        writer.writeNumberValue("diskInGb", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.diskInGb);
        writer.writeNumberValue("memoryInGb", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.memoryInGb);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceRecurring", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.priceRecurring, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto>("priceStartup", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.priceStartup, serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto);
        writer.writeNumberValue("subscriptionId", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.subscriptionId);
        writer.writeStringValue("subscriptionName", webhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto.subscriptionName);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesSharedModelsAddOnCartItem(writer: SerializationWriter, webhusetOrderApiFeaturesSharedModelsAddOnCartItem: Partial<WebhusetOrderApiFeaturesSharedModelsAddOnCartItem> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesSharedModelsAddOnCartItem) {
        writer.writeNumberValue("addOnId", webhusetOrderApiFeaturesSharedModelsAddOnCartItem.addOnId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesSharedModelsCartItem(writer: SerializationWriter, webhusetOrderApiFeaturesSharedModelsCartItem: Partial<WebhusetOrderApiFeaturesSharedModelsCartItem> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesSharedModelsCartItem) {
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsAddOnCartItem>("addOn", webhusetOrderApiFeaturesSharedModelsCartItem.addOn, serializeWebhusetOrderApiFeaturesSharedModelsAddOnCartItem);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsDomainCartItem>("chat", webhusetOrderApiFeaturesSharedModelsCartItem.chat, serializeWebhusetOrderApiFeaturesSharedModelsDomainCartItem);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsDomainCartItem>("domain", webhusetOrderApiFeaturesSharedModelsCartItem.domain, serializeWebhusetOrderApiFeaturesSharedModelsDomainCartItem);
        writer.writeStringValue("id", webhusetOrderApiFeaturesSharedModelsCartItem.id);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem>("microsoft365", webhusetOrderApiFeaturesSharedModelsCartItem.microsoft365, serializeWebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem);
        writer.writeStringValue("parentItemId", webhusetOrderApiFeaturesSharedModelsCartItem.parentItemId);
        writer.writeObjectValue<WebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem>("virtualServer", webhusetOrderApiFeaturesSharedModelsCartItem.virtualServer, serializeWebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto(writer: SerializationWriter, webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto: Partial<WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto) {
        writer.writeStringValue("description", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.description);
        writer.writeNumberValue("discount", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.discount);
        writer.writeNumberValue("discountValue", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.discountValue);
        writer.writeNumberValue("duration", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.duration);
        writer.writeNumberValue("priceExVat", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.priceExVat);
        writer.writeNumberValue("priceIncVat", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.priceIncVat);
        writer.writeNumberValue("unitPrice", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.unitPrice);
        writer.writeNumberValue("unitPriceWithDiscount", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.unitPriceWithDiscount);
        writer.writeNumberValue("units", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.units);
        writer.writeNumberValue("vat", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.vat);
        writer.writeNumberValue("vatValue", webhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto.vatValue);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesSharedModelsDomainCartItem(writer: SerializationWriter, webhusetOrderApiFeaturesSharedModelsDomainCartItem: Partial<WebhusetOrderApiFeaturesSharedModelsDomainCartItem> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesSharedModelsDomainCartItem) {
        writer.writeStringValue("domain", webhusetOrderApiFeaturesSharedModelsDomainCartItem.domain);
        writer.writeStringValue("fqdn", webhusetOrderApiFeaturesSharedModelsDomainCartItem.fqdn);
        writer.writeEnumValue<WebhusetOrderApiDataDomainRegistrationType>("registrationType", webhusetOrderApiFeaturesSharedModelsDomainCartItem.registrationType);
        writer.writeStringValue("tld", webhusetOrderApiFeaturesSharedModelsDomainCartItem.tld);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem(writer: SerializationWriter, webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem: Partial<WebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem) {
        writer.writeStringValue("alternateEmail", webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.alternateEmail);
        writer.writeStringValue("firstName", webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.firstName);
        writer.writeBooleanValue("hasCoPilot", webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.hasCoPilot);
        writer.writeStringValue("lastName", webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.lastName);
        writer.writeNumberValue("subscriptionId", webhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem.subscriptionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem(writer: SerializationWriter, webhusetOrderApiFeaturesSharedModelsVirtualServerCartItem: Partial<WebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem> | undefined | null = {}) : void {
    if (webhusetOrderApiFeaturesSharedModelsVirtualServerCartItem) {
        writer.writeNumberValue("subscriptionId", webhusetOrderApiFeaturesSharedModelsVirtualServerCartItem.subscriptionId);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto) {
        writer.writeStringValue("email", webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto.email);
        writer.writeStringValue("onboarding_id", webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto.onboardingId);
        writer.writeNumberValue("subscription", webhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto.subscription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto) {
        writer.writeNumberValue("addon", webhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto.addon);
        writer.writeNumberValue("domain", webhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto.domain);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto) {
        writer.writeCollectionOfPrimitiveValues<number>("addons", webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.addons);
        writer.writeStringValue("domain", webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.domain);
        writer.writeBooleanValue("is_temporary", webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.isTemporary);
        writer.writeBooleanValue("is_third_party", webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.isThirdParty);
        writer.writeNumberValue("os", webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.os);
        writer.writeNumberValue("registration_type", webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.registrationType);
        writer.writeNumberValue("subscription", webhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto.subscription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto) {
        writer.writeStringValue("alternate_email", webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto.alternateEmail);
        writer.writeStringValue("first_name", webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto.firstName);
        writer.writeStringValue("last_name", webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto.lastName);
        writer.writeNumberValue("subscription", webhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto.subscription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto) {
        writer.writeCollectionOfPrimitiveValues<number>("addons", webhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto.addons);
        writer.writeNumberValue("subscription", webhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto.subscription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddRestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddRestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddRestDto) {
        writer.writeBooleanValue("automatic_recurring_payment", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.automaticRecurringPayment);
        writer.writeCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto>("chats", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.chats, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto);
        writer.writeStringValue("checkout_key", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.checkoutKey);
        writer.writeStringValue("client_ip_address", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.clientIpAddress);
        writer.writeStringValue("comment", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.comment);
        writer.writeStringValue("coupon", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.coupon);
        writer.writeNumberValue("customerid", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.customerid);
        writer.writeObjectValue<WebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto>("domain_addon", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.domainAddon, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto);
        writer.writeCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto>("domains", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.domains, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto);
        writer.writeBooleanValue("is_ppc", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.isPpc);
        writer.writeCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto>("office365s", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.office365s, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto);
        writer.writeNumberValue("partnerid", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.partnerid);
        writer.writeNumberValue("payment_type", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.paymentType);
        writer.writeCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto>("racks", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.racks, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto);
        writer.writeObjectValue<WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto>("server_addon", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.serverAddon, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto);
        writer.writeCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto>("server_addons", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.serverAddons, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto);
        writer.writeCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto>("servers", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.servers, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto);
        writer.writeNumberValue("sms_verify_code_id", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.smsVerifyCodeId);
        writer.writeStringValue("utm_campaign", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.utmCampaign);
        writer.writeStringValue("utm_term", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.utmTerm);
        writer.writeCollectionOfObjectValues<WebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto>("vpsclones", webhusetOuterfaceApiRestDtoOrderOrderAddRestDto.vpsclones, serializeWebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto) {
        writer.writeNumberValue("addon", webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto.addon);
        writer.writeNumberValue("changedfromserveraddonid", webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto.changedfromserveraddonid);
        writer.writeNumberValue("server", webhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto.server);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto) {
        writer.writeCollectionOfPrimitiveValues<number>("addons", webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto.addons);
        writer.writeNumberValue("availability_zone", webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto.availabilityZone);
        writer.writeNumberValue("subscription", webhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto.subscription);
    }
}
/**
 * Serializes information the current object
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto(writer: SerializationWriter, webhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto: Partial<WebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto> | undefined | null = {}) : void {
    if (webhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto) {
        writer.writeNumberValue("serverid", webhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto.serverid);
        writer.writeNumberValue("target_subscription", webhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto.targetSubscription);
    }
}
export type WebhusetConstantsOrderAgreementPeriodTypeItem = (typeof WebhusetConstantsOrderAgreementPeriodTypeItemObject)[keyof typeof WebhusetConstantsOrderAgreementPeriodTypeItemObject];
export type WebhusetOrderApiDataCustomerDeviceTypeItem = (typeof WebhusetOrderApiDataCustomerDeviceTypeItemObject)[keyof typeof WebhusetOrderApiDataCustomerDeviceTypeItemObject];
export type WebhusetOrderApiDataDomainRegistrationType = (typeof WebhusetOrderApiDataDomainRegistrationTypeObject)[keyof typeof WebhusetOrderApiDataDomainRegistrationTypeObject];
export type WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem = (typeof WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItemObject)[keyof typeof WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItemObject];
export type WebhusetOrderApiDataInvoicePaymentMethodTypeItem = (typeof WebhusetOrderApiDataInvoicePaymentMethodTypeItemObject)[keyof typeof WebhusetOrderApiDataInvoicePaymentMethodTypeItemObject];
export type WebhusetOrderApiDataOrderPaymentMethodTypeItem = (typeof WebhusetOrderApiDataOrderPaymentMethodTypeItemObject)[keyof typeof WebhusetOrderApiDataOrderPaymentMethodTypeItemObject];
export interface WebhusetOrderApiFeaturesCartCouponPutRequest extends Parsable {
    /**
     * The coupon property
     */
    coupon?: string | null;
}
export interface WebhusetOrderApiFeaturesCartCouponPutResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface WebhusetOrderApiFeaturesCartCreateRequest extends Parsable {
    /**
     * The companyProfileId property
     */
    companyProfileId?: number | null;
    /**
     * The deviceType property
     */
    deviceType?: WebhusetOrderApiDataCustomerDeviceTypeItem | null;
    /**
     * The isPpc property
     */
    isPpc?: boolean | null;
    /**
     * The utmCampaign property
     */
    utmCampaign?: string | null;
    /**
     * The utmTerm property
     */
    utmTerm?: string | null;
}
export interface WebhusetOrderApiFeaturesCartCreateResponse extends Parsable {
    /**
     * The domainSubscriptionPaymentInterval property
     */
    domainSubscriptionPaymentInterval?: WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem | null;
    /**
     * The id property
     */
    id?: string | null;
}
export interface WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutRequest extends Parsable {
    /**
     * The domainSubscriptionPaymentInterval property
     */
    domainSubscriptionPaymentInterval?: WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem | null;
}
export interface WebhusetOrderApiFeaturesCartDomainSubscriptionPaymentIntervalPutResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface WebhusetOrderApiFeaturesCartFinalizeRequest extends Parsable {
    /**
     * The orderId property
     */
    orderId?: number | null;
}
export interface WebhusetOrderApiFeaturesCartFinalizeResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface WebhusetOrderApiFeaturesCartGetResponse extends Parsable {
    /**
     * The coupon property
     */
    coupon?: string | null;
    /**
     * The domainSubscriptionPaymentInterval property
     */
    domainSubscriptionPaymentInterval?: WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItem | null;
    /**
     * The isFinalized property
     */
    isFinalized?: boolean | null;
    /**
     * The items property
     */
    items?: WebhusetOrderApiFeaturesSharedModelsCartItem[] | null;
}
export interface WebhusetOrderApiFeaturesCartItemAddOnAddRequest extends Parsable {
    /**
     * The addOnId property
     */
    addOnId?: number | null;
    /**
     * The replacesAddOnIds property
     */
    replacesAddOnIds?: number[] | null;
}
export interface WebhusetOrderApiFeaturesCartItemAddOnAddResponse extends Parsable {
    /**
     * The item property
     */
    item?: WebhusetOrderApiFeaturesSharedModelsCartItem | null;
}
export interface WebhusetOrderApiFeaturesCartItemDeleteResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface WebhusetOrderApiFeaturesCartItemDomainAddRequest extends Parsable {
    /**
     * The domain property
     */
    domain?: string | null;
    /**
     * The registrationType property
     */
    registrationType?: WebhusetOrderApiDataDomainRegistrationType | null;
    /**
     * The tld property
     */
    tld?: string | null;
}
export interface WebhusetOrderApiFeaturesCartItemDomainAddResponse extends Parsable {
    /**
     * The item property
     */
    item?: WebhusetOrderApiFeaturesSharedModelsCartItem | null;
}
export interface WebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest extends Parsable {
    /**
     * The alternateEmail property
     */
    alternateEmail?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The hasCoPilot property
     */
    hasCoPilot?: boolean | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The subscriptionId property
     */
    subscriptionId?: number | null;
}
export interface WebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse extends Parsable {
    /**
     * The item property
     */
    item?: WebhusetOrderApiFeaturesSharedModelsCartItem | null;
}
export interface WebhusetOrderApiFeaturesCartItemMicrosoft365PutRequest extends Parsable {
    /**
     * The alternateEmail property
     */
    alternateEmail?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The hasCoPilot property
     */
    hasCoPilot?: boolean | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The subscriptionId property
     */
    subscriptionId?: number | null;
}
export interface WebhusetOrderApiFeaturesCartItemMicrosoft365PutResponse extends Parsable {
    /**
     * The item property
     */
    item?: WebhusetOrderApiFeaturesSharedModelsCartItem | null;
}
export interface WebhusetOrderApiFeaturesCartItemVpsAddRequest extends Parsable {
    /**
     * The subscriptionId property
     */
    subscriptionId?: number | null;
}
export interface WebhusetOrderApiFeaturesCartItemVpsAddResponse extends Parsable {
    /**
     * The item property
     */
    item?: WebhusetOrderApiFeaturesSharedModelsCartItem | null;
}
export interface WebhusetOrderApiFeaturesCartLinkToCustomerRequest extends Parsable {
    /**
     * The customerId property
     */
    customerId?: number | null;
    /**
     * The partnerId property
     */
    partnerId?: number | null;
}
export interface WebhusetOrderApiFeaturesCartLinkToCustomerResponse extends Parsable {
    /**
     * The success property
     */
    success?: boolean | null;
}
export interface WebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto extends AdditionalDataHolder, Parsable, WebhusetOuterfaceApiRestDtoOrderOrderAddRestDto {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The return_url property
     */
    returnUrl?: string | null;
}
export interface WebhusetOrderApiFeaturesCartOrderPrepareRequest extends Parsable {
    /**
     * The paymentMethod property
     */
    paymentMethod?: WebhusetOrderApiDataOrderPaymentMethodTypeItem | null;
    /**
     * The returnUrl property
     */
    returnUrl?: string | null;
    /**
     * The smsVerificationTransactionId property
     */
    smsVerificationTransactionId?: number | null;
}
export interface WebhusetOrderApiFeaturesCartOrderPrepareResponse extends Parsable {
    /**
     * The orderData property
     */
    orderData?: WebhusetOrderApiFeaturesCartOrderPrepareExtendedOrderAddRestDto | null;
}
export interface WebhusetOrderApiFeaturesCartQuoteRequest extends Parsable {
    /**
     * The apiKey property
     */
    apiKey?: string | null;
    /**
     * The impersonateCustomerId property
     */
    impersonateCustomerId?: number | null;
}
export interface WebhusetOrderApiFeaturesCartQuoteResponse extends Parsable {
    /**
     * The sumFirstInvoiceExVat property
     */
    sumFirstInvoiceExVat?: number | null;
    /**
     * The sumFirstInvoiceIncVat property
     */
    sumFirstInvoiceIncVat?: number | null;
    /**
     * The sumVatFirstInvoice property
     */
    sumVatFirstInvoice?: number | null;
}
export interface WebhusetOrderApiFeaturesCartQuoteResponseWithDomainDiscountExceeded extends AdditionalDataHolder, ApiError, Parsable, WebhusetOrderApiFeaturesCartQuoteResponse {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     */
    additionalData?: Record<string, unknown>;
    /**
     * The domainsWithDiscountAlreadyExistCount property
     */
    domainsWithDiscountAlreadyExistCount?: number | null;
    /**
     * The domainsWithDiscountInCurrentOrderCount property
     */
    domainsWithDiscountInCurrentOrderCount?: number | null;
    /**
     * The domainsWithDiscountMaxCount property
     */
    domainsWithDiscountMaxCount?: number | null;
}
export interface WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse extends Parsable {
    /**
     * The products property
     */
    products?: WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultRestDto extends Parsable {
    /**
     * The addOnType property
     */
    addOnType?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The subscriptions property
     */
    subscriptions?: WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogDomainAddOnsGetResponse_CatalogDomainAddOnItemResultSubscriptionRestDto extends Parsable {
    /**
     * The addOnId property
     */
    addOnId?: number | null;
    /**
     * The agreementPeriodType property
     */
    agreementPeriodType?: WebhusetConstantsOrderAgreementPeriodTypeItem | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The priceRecurring property
     */
    priceRecurring?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The priceStartup property
     */
    priceStartup?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
}
export interface WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse extends Parsable {
    /**
     * The options property
     */
    options?: WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogInvoiceFeeGetResponse_CatalogInvoiceFeeItemResultRestDto extends Parsable {
    /**
     * The individuals property
     */
    individuals?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The invoiceMethodItem property
     */
    invoiceMethodItem?: WebhusetOrderApiDataInvoicePaymentMethodTypeItem | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The organizations property
     */
    organizations?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
}
export interface WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse extends Parsable {
    /**
     * The products property
     */
    products?: WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultRestDto extends Parsable {
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The packageId property
     */
    packageId?: number | null;
    /**
     * The subscriptions property
     */
    subscriptions?: WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogMicrosoft365GetResponse_CatalogMicrosoft365ItemResultSubscriptionRestDto extends Parsable {
    /**
     * The agreementPeriodType property
     */
    agreementPeriodType?: WebhusetConstantsOrderAgreementPeriodTypeItem | null;
    /**
     * The priceRecurring property
     */
    priceRecurring?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The priceStartup property
     */
    priceStartup?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The subscriptionId property
     */
    subscriptionId?: number | null;
    /**
     * The subscriptionName property
     */
    subscriptionName?: string | null;
}
export interface WebhusetOrderApiFeaturesCatalogTldGetResponse extends Parsable {
    /**
     * The products property
     */
    products?: WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto extends Parsable {
    /**
     * The priceRecurring property
     */
    priceRecurring?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The priceStartup property
     */
    priceStartup?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The tld property
     */
    tld?: string | null;
}
export interface WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse extends Parsable {
    /**
     * The products property
     */
    products?: WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto extends Parsable {
    /**
     * The addOnType property
     */
    addOnType?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The subscriptions property
     */
    subscriptions?: WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultSubscriptionRestDto extends Parsable {
    /**
     * The addOnId property
     */
    addOnId?: number | null;
    /**
     * The agreementPeriodType property
     */
    agreementPeriodType?: WebhusetConstantsOrderAgreementPeriodTypeItem | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The priceRecurring property
     */
    priceRecurring?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The priceStartup property
     */
    priceStartup?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
}
export interface WebhusetOrderApiFeaturesCatalogVpsGetResponse extends Parsable {
    /**
     * The products property
     */
    products?: WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto[] | null;
}
export interface WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto extends Parsable {
    /**
     * The distroId property
     */
    distroId?: number | null;
    /**
     * The osFamily property
     */
    osFamily?: number | null;
    /**
     * The subscriptions property
     */
    subscriptions?: WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto[] | null;
    /**
     * The templateId property
     */
    templateId?: number | null;
    /**
     * The templateName property
     */
    templateName?: string | null;
}
export interface WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto extends Parsable {
    /**
     * The agreementPeriodType property
     */
    agreementPeriodType?: WebhusetConstantsOrderAgreementPeriodTypeItem | null;
    /**
     * The cpuCount property
     */
    cpuCount?: number | null;
    /**
     * The diskInGb property
     */
    diskInGb?: number | null;
    /**
     * The memoryInGb property
     */
    memoryInGb?: number | null;
    /**
     * The priceRecurring property
     */
    priceRecurring?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The priceStartup property
     */
    priceStartup?: WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto | null;
    /**
     * The subscriptionId property
     */
    subscriptionId?: number | null;
    /**
     * The subscriptionName property
     */
    subscriptionName?: string | null;
}
export interface WebhusetOrderApiFeaturesSharedModelsAddOnCartItem extends Parsable {
    /**
     * The addOnId property
     */
    addOnId?: number | null;
}
export interface WebhusetOrderApiFeaturesSharedModelsCartItem extends Parsable {
    /**
     * The addOn property
     */
    addOn?: WebhusetOrderApiFeaturesSharedModelsAddOnCartItem | null;
    /**
     * The chat property
     */
    chat?: WebhusetOrderApiFeaturesSharedModelsDomainCartItem | null;
    /**
     * The domain property
     */
    domain?: WebhusetOrderApiFeaturesSharedModelsDomainCartItem | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The microsoft365 property
     */
    microsoft365?: WebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem | null;
    /**
     * The parentItemId property
     */
    parentItemId?: string | null;
    /**
     * The virtualServer property
     */
    virtualServer?: WebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem | null;
}
export interface WebhusetOrderApiFeaturesSharedModelsCatalogPriceResultRestDto extends Parsable {
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The discount property
     */
    discount?: number | null;
    /**
     * The discountValue property
     */
    discountValue?: number | null;
    /**
     * The duration property
     */
    duration?: number | null;
    /**
     * The priceExVat property
     */
    priceExVat?: number | null;
    /**
     * The priceIncVat property
     */
    priceIncVat?: number | null;
    /**
     * The unitPrice property
     */
    unitPrice?: number | null;
    /**
     * The unitPriceWithDiscount property
     */
    unitPriceWithDiscount?: number | null;
    /**
     * The units property
     */
    units?: number | null;
    /**
     * The vat property
     */
    vat?: number | null;
    /**
     * The vatValue property
     */
    vatValue?: number | null;
}
export interface WebhusetOrderApiFeaturesSharedModelsDomainCartItem extends Parsable {
    /**
     * The domain property
     */
    domain?: string | null;
    /**
     * The fqdn property
     */
    fqdn?: string | null;
    /**
     * The registrationType property
     */
    registrationType?: WebhusetOrderApiDataDomainRegistrationType | null;
    /**
     * The tld property
     */
    tld?: string | null;
}
export interface WebhusetOrderApiFeaturesSharedModelsMicrosoft365CartItem extends Parsable {
    /**
     * The alternateEmail property
     */
    alternateEmail?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The hasCoPilot property
     */
    hasCoPilot?: boolean | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The subscriptionId property
     */
    subscriptionId?: number | null;
}
export interface WebhusetOrderApiFeaturesSharedModelsVirtualServerCartItem extends Parsable {
    /**
     * The subscriptionId property
     */
    subscriptionId?: number | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto extends Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The onboarding_id property
     */
    onboardingId?: string | null;
    /**
     * The subscription property
     */
    subscription?: number | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto extends Parsable {
    /**
     * The addon property
     */
    addon?: number | null;
    /**
     * The domain property
     */
    domain?: number | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto extends Parsable {
    /**
     * The addons property
     */
    addons?: number[] | null;
    /**
     * The domain property
     */
    domain?: string | null;
    /**
     * The is_temporary property
     */
    isTemporary?: boolean | null;
    /**
     * The is_third_party property
     */
    isThirdParty?: boolean | null;
    /**
     * The os property
     */
    os?: number | null;
    /**
     * The registration_type property
     */
    registrationType?: number | null;
    /**
     * The subscription property
     */
    subscription?: number | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto extends Parsable {
    /**
     * The alternate_email property
     */
    alternateEmail?: string | null;
    /**
     * The first_name property
     */
    firstName?: string | null;
    /**
     * The last_name property
     */
    lastName?: string | null;
    /**
     * The subscription property
     */
    subscription?: number | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto extends Parsable {
    /**
     * The addons property
     */
    addons?: number[] | null;
    /**
     * The subscription property
     */
    subscription?: number | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddRestDto extends Parsable {
    /**
     * The automatic_recurring_payment property
     */
    automaticRecurringPayment?: boolean | null;
    /**
     * The chats property
     */
    chats?: WebhusetOuterfaceApiRestDtoOrderOrderAddChatRestDto[] | null;
    /**
     * The checkout_key property
     */
    checkoutKey?: string | null;
    /**
     * The client_ip_address property
     */
    clientIpAddress?: string | null;
    /**
     * The comment property
     */
    comment?: string | null;
    /**
     * The coupon property
     */
    coupon?: string | null;
    /**
     * The customerid property
     */
    customerid?: number | null;
    /**
     * The domain_addon property
     */
    domainAddon?: WebhusetOuterfaceApiRestDtoOrderOrderAddDomainAddOnRestDto | null;
    /**
     * The domains property
     */
    domains?: WebhusetOuterfaceApiRestDtoOrderOrderAddDomainRestDto[] | null;
    /**
     * The is_ppc property
     */
    isPpc?: boolean | null;
    /**
     * The office365s property
     */
    office365s?: WebhusetOuterfaceApiRestDtoOrderOrderAddOffice365RestDto[] | null;
    /**
     * The partnerid property
     */
    partnerid?: number | null;
    /**
     * The payment_type property
     */
    paymentType?: number | null;
    /**
     * The racks property
     */
    racks?: WebhusetOuterfaceApiRestDtoOrderOrderAddRackRestDto[] | null;
    /**
     * The server_addon property
     */
    serverAddon?: WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto | null;
    /**
     * The server_addons property
     */
    serverAddons?: WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto[] | null;
    /**
     * The servers property
     */
    servers?: WebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto[] | null;
    /**
     * The sms_verify_code_id property
     */
    smsVerifyCodeId?: number | null;
    /**
     * The utm_campaign property
     */
    utmCampaign?: string | null;
    /**
     * The utm_term property
     */
    utmTerm?: string | null;
    /**
     * The vpsclones property
     */
    vpsclones?: WebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto[] | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddServerAddOnRestDto extends Parsable {
    /**
     * The addon property
     */
    addon?: number | null;
    /**
     * The changedfromserveraddonid property
     */
    changedfromserveraddonid?: number | null;
    /**
     * The server property
     */
    server?: number | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddServerRestDto extends Parsable {
    /**
     * The addons property
     */
    addons?: number[] | null;
    /**
     * The availability_zone property
     */
    availabilityZone?: number | null;
    /**
     * The subscription property
     */
    subscription?: number | null;
}
export interface WebhusetOuterfaceApiRestDtoOrderOrderAddVpsCloneRestDto extends Parsable {
    /**
     * The serverid property
     */
    serverid?: number | null;
    /**
     * The target_subscription property
     */
    targetSubscription?: number | null;
}
export const WebhusetConstantsOrderAgreementPeriodTypeItemObject = {
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Yearly: "Yearly",
    Triennielly: "Triennielly",
    Biennially: "Biennially",
} as const;
export const WebhusetOrderApiDataCustomerDeviceTypeItemObject = {
    Desktop: "Desktop",
    Mobile: "Mobile",
    Tablet: "Tablet",
} as const;
export const WebhusetOrderApiDataDomainRegistrationTypeObject = {
    NewEscaped: "New",
    Transfer: "Transfer",
    ThirdParty: "ThirdParty",
} as const;
export const WebhusetOrderApiDataDomainSubscriptionPaymentIntervalItemObject = {
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    SemiAnnually: "SemiAnnually",
    Annually: "Annually",
    Biannually: "Biannually",
} as const;
export const WebhusetOrderApiDataInvoicePaymentMethodTypeItemObject = {
    Paper: "Paper",
    Email: "Email",
    Ehf: "Ehf",
} as const;
export const WebhusetOrderApiDataOrderPaymentMethodTypeItemObject = {
    Invoice: "Invoice",
    CreditCard: "CreditCard",
    RecurringCreditCard: "RecurringCreditCard",
} as const;
/* tslint:enable */
/* eslint-enable */
